var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/img_category_bg.d34bf9e6.png","uri@2x": __webpack_public_path__ + "static/media/img_category_bg.0b791da1.png","uri@3x": __webpack_public_path__ + "static/media/img_category_bg.39d94abd.png",
    width: 62,
    height: 62
});